import { render, staticRenderFns } from "./PaymentBreakdowns.vue?vue&type=template&id=467b11e7&scoped=true"
import script from "./PaymentBreakdowns.vue?vue&type=script&lang=js"
export * from "./PaymentBreakdowns.vue?vue&type=script&lang=js"
import style0 from "./PaymentBreakdowns.vue?vue&type=style&index=0&id=467b11e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467b11e7",
  null
  
)

export default component.exports